

export const errorCodeTexts = {
    "404" : "Страница не найдена",
    "403" : "Нет прав на просмотр страницы",
    "423" : "Аккаунт заблокирован",
    "500" : "Ошибка на сервере"
}